module.exports = __webpack_public_path__ + "static/media/minus.1731e2bd.svg";